import {FC, useEffect} from 'react'
import {useLang} from './LangConfig'
import {IntlProvider, useIntl} from 'react-intl'
import {setIntlInstance} from '../../app/utils/i18nExtension'
import '@formatjs/intl-relativetimeformat/polyfill'
import '@formatjs/intl-relativetimeformat/locale-data/en'
import '@formatjs/intl-relativetimeformat/locale-data/de'
import '@formatjs/intl-relativetimeformat/locale-data/es'
import '@formatjs/intl-relativetimeformat/locale-data/fr'
import '@formatjs/intl-relativetimeformat/locale-data/ja'
import '@formatjs/intl-relativetimeformat/locale-data/zh'
// Note: no @formatjs/intl-relativetimeformat locale-data for Tamil (ta) — falls back gracefully

import deMessages from './messages/de.json'
import enMessages from './messages/en.json'
import esMessages from './messages/es.json'
import frMessages from './messages/fr.json'
import jaMessages from './messages/ja.json'
import taMessages from './messages/ta.json'
import zhMessages from './messages/zh.json'
import {WithChildren} from '../helpers'
import {brand} from '../../app/modules/settings/BrandSettings'

const allMessages = {
  de: deMessages,
  en: enMessages,
  es: esMessages,
  fr: frMessages,
  ja: jaMessages,
  ta: taMessages,
  zh: zhMessages,
}

// Brand-specific translation overrides, merged on top of allMessages.
const brandOverrides: Partial<Record<string, Partial<Record<keyof typeof allMessages, Record<string, string>>>>> = {
  munily: {
    es: {
      Sales: 'Ingresos',
      Expenses: 'Egresos',
    },
  },
}

// Renders nothing — just keeps the global intl reference in sync so
// String.prototype.toTranslatedDisplay() works outside React components.
const IntlSync: FC = () => {
  const intl = useIntl()
  useEffect(() => {
    setIntlInstance(intl)
  }, [intl])
  return null
}

const I18nProvider: FC<WithChildren> = ({children}) => {
  const locale = useLang()
  const messages = {...allMessages[locale], ...brandOverrides[brand]?.[locale]}

  return (
    <IntlProvider locale={locale} messages={messages}>
      <IntlSync />
      {children}
    </IntlProvider>
  )
}

export {I18nProvider}
